/**
 * ProtectedRoute - Wrapper component that requires authentication
 */
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, loading, checkAuth, user } = useAuth();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // If user passed from AuthCallback, skip auth check
    if (location.state?.user) {
      setChecking(false);
      return;
    }

    const verifyAuth = async () => {
      if (!loading) {
        if (!isAuthenticated) {
          // Re-check auth in case cookie was set
          await checkAuth();
        }
        setChecking(false);
      }
    };

    verifyAuth();
  }, [loading, isAuthenticated, checkAuth, location.state]);

  useEffect(() => {
    if (!checking && !loading && !isAuthenticated && !location.state?.user) {
      navigate('/login', { replace: true });
    }
  }, [checking, loading, isAuthenticated, navigate, location.state]);

  if (loading || checking) {
    return (
      <div className="min-h-screen bg-zinc-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-[#0055FF] mx-auto mb-4" />
          <p className="text-zinc-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated && !location.state?.user) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
